// extracted by mini-css-extract-plugin
export default {"CreateRoundConfigModalDialog":"CreateRoundConfigModalDialog_CreateRoundConfigModalDialog__iK+uw"};